module.exports = __webpack_public_path__ + "housingStatic/img/moudle_name_item2.221f163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_center/moudle_name_item2.png
// module id = rDaq
// module chunks = 2